<div class="container" [class.mobile]="isMobile">
  <p class="top-text">{{ "facility.hotelList" | translate }}</p>

  <div *ngIf="!isMobile" class="desktop-view">
    <table class="items-table">
      <tr *ngFor="let row of rows">
        <td>
          <div
            *ngIf="row.col1"
            [class.area-header]="row.col1.isArea"
            [class.facility-item]="!row.col1.isArea"
          >
            <ng-container *ngIf="row.col1.isArea">
              {{ "facility.area" | translate }} {{ row.col1.text }}
            </ng-container>
            <ng-container *ngIf="!row.col1.isArea">
              {{ row.col1.text }}
            </ng-container>
          </div>
        </td>
        <td>
          <div
            *ngIf="row.col2"
            [class.area-header]="row.col2.isArea"
            [class.facility-item]="!row.col2.isArea"
          >
            <ng-container *ngIf="row.col2.isArea">
              {{ "facility.area" | translate }} {{ row.col2.text }}
            </ng-container>
            <ng-container *ngIf="!row.col2.isArea">
              {{ row.col2.text }}
            </ng-container>
          </div>
        </td>
      </tr>
    </table>
  </div>

  <div *ngIf="isMobile" class="mobile-view">
    <div class="accordion">
      <div *ngFor="let category of categories" class="accordion-item">
        <button (click)="selectCategory(category)" class="accordion-header">
          {{ "facility.area" | translate }} {{ category }}
          <span class="arrow" [class.open]="selectedCategory === category">
            {{ selectedCategory === category ? "-" : "+" }}
          </span>
        </button>
        <ul *ngIf="selectedCategory === category" class="accordion-list">
          <li *ngFor="let item of filteredItemsByCategory(category)">
            {{ selectedLang === 0 ? item.name : item.nameEnglish }}
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="action-content">
    <button pButton (click)="moveToTop()" class="active-button">
      {{ "facility.top" | translate }}
    </button>
  </div>
</div>
